import { motion } from 'motion/react';

import { ITransaction } from '@/entities/transaction';

import { VabsPaymentStatus } from '@/shared/api';
import { PendingDotsIcon } from '@/shared/assets';
import { COLORS, cn } from '@/shared/lib';
import { Header, Typography } from '@/shared/ui';

import { TransactionDetailGroup } from './group';

type StatusType = 'done' | 'process' | 'pending';

interface StatusItemProps {
  title: string;
  value: string;
  status: StatusType;
}

const StatusItem = ({ title, value, status }: StatusItemProps) => {
  return (
    <div className="flex gap-x-3">
      <div className="relative">
        <div
          className={cn('h-[60px] w-[4px] rounded-[5px]', {
            'bg-icon-brand-500': status === 'done',
            'bg-icon-base-100': status === 'pending',
          })}
        />
        {status === 'process' && (
          <div className="absolute left-0 top-0 h-[60px] w-[4px] overflow-hidden rounded-[5px]">
            <motion.div
              className="absolute left-0 top-0 h-[128px] w-[4px]"
              style={{
                maskImage: `url("${PendingDotsIcon}")`,
                background: COLORS['icon-brand-500'],
                backgroundRepeat: 'repeat-y',
              }}
              animate={{ y: [-64, 0] }}
              transition={{
                repeat: Infinity,
                duration: 4,
                ease: 'linear',
                repeatType: 'loop',
              }}
            />
          </div>
        )}
      </div>

      <div className="flex flex-col gap-y-1 py-2">
        <Typography
          color={status === 'pending' ? 'text-base-100' : 'default'}
          variant="16-m"
        >
          {title}
        </Typography>
        <Typography
          color={status === 'pending' ? 'text-base-100' : 'default'}
          variant="14-r"
        >
          {value}
        </Typography>
      </div>
    </div>
  );
};
const REVIEW_STATUS = [VabsPaymentStatus.NeedAction, VabsPaymentStatus.OnReview]
export const Status = (tx: ITransaction) => {
  return (
    <TransactionDetailGroup className="mb-1 gap-y-4">
      <Header title="Payment in progress" />

      <div className="flex w-full flex-col items-start gap-y-3">
        <StatusItem
          title={REVIEW_STATUS.includes(tx.status) ? "Reviewing" : "Reviewed"}
          value={REVIEW_STATUS.includes(tx.status) ? "Est. Tomorrow" : "Today"}
          status={REVIEW_STATUS.includes(tx.status) ? 'process' : 'done'}
        />

        <StatusItem
          title="Pending"
          value="Est. Tomorrow"
          status={
            tx.status === VabsPaymentStatus.Processing ? 'process' : 'pending'
          }
        />

        <StatusItem title="Success" value="Est. Tomorrow " status="pending" />
      </div>
    </TransactionDetailGroup>
  );
};
